/** Tracks pending IndexedDB writes. A failed write blocks an explicit client refresh. */
const pending = new Set<Promise<unknown>>();
let failed = false;
export function trackOperatorDraftWrite<T>(work: Promise<T>): Promise<T> {
  pending.add(work);
  void work.then(() => undefined, () => { failed = true; }).finally(() => pending.delete(work));
  return work;
}
export async function flushOperatorDraftWrites() {
  await Promise.all([...pending].map((work) => work.catch(() => undefined)));
  return !failed && pending.size === 0;
}
